if (!customElements.get('menu-swiper')) {
    class MenuSwiper extends HTMLElement {
        initialized = false;

        constructor() {
            super();
        }

        init() {
            if (!this.initialized) {
                // First initialization.
                this.checkSubmenus();
                this.switchProductList();
                this.initialized = true;
            }
        }

        checkSubmenus() {
            const menuListOuter = this.querySelectorAll('.menu-item-has-grandchild-container-product-box-list-outer');
            this.swipers = [];
            if (menuListOuter.length == 0) return;
            for (const menuOuter of menuListOuter) {
                setTimeout(() => {
                    const menuList = menuOuter.querySelector('.menu-item-has-grandchild-container-product-box-list');
                    const nextButton = menuOuter.querySelector('.swiper-button-next');
                    const prevButton = menuOuter.querySelector('.swiper-button-prev');
                    const number = parseInt(this.getAttribute('data-number'), 10) || 4;
                    const centerInsufficientSlides = this.getAttribute('data-center-insufficient-slides') === 'true';
                    const swiper = new Swiper(menuList, {
                        slidesPerView: number || 4,
                        spaceBetween: 30,
                        observer: true,
                        navigation: {
                            nextEl: nextButton || null,
                            prevEl: prevButton || null,
                        },
                        ...(centerInsufficientSlides && { centerInsufficientSlides: true }),
                        on: {
                            init: function (swiper) {
                                const hideElements = menuList.parentElement;
                                if (hideElements && hideElements.getAttribute('aria-expanded') === 'false') {
                                    // console.log(hideElements, 'hideElements');
                                    hideElements.style.display = 'none';
                                }
                            },
                        },
                    });

                    this.swipers.push(swiper);
                        
                }, 0);
            }
        }

        switchProductList() {
            const menuTitleList = this.querySelector('.menu-item-has-grandchild-container-list');
            const menuProductList = this.querySelector('.menu-item-has-grandchild-container-product-box');
            if (menuTitleList) {
                const menuTitles = menuTitleList.querySelectorAll('.menu-item-children-item[data-collection]');
                const menuProductContainers = menuProductList.querySelectorAll('.menu-item-has-grandchild-container-product-box-list-outer[data-collection]');

                if (menuTitles.length == 0) return;
                for (const menuTitle of menuTitles) {
                    setTimeout(() => {
                        menuTitle.addEventListener('mouseenter', () => {
                            menuTitles.forEach((title) => {
                                title.setAttribute('aria-expanded', 'false');
                            })
                            menuTitle.setAttribute('aria-expanded', 'true');

                            const targetData = menuTitle.getAttribute('data-collection');

                            const targetProductContainer = Array.from(menuProductContainers).find(container =>
                                container.getAttribute('data-collection') === targetData
                            );

                            if (targetProductContainer) {
                                menuProductContainers.forEach(container => {
                                    container.setAttribute('aria-expanded', 'false');
                                    container.style.display = 'none';
                                });
                                targetProductContainer.setAttribute('aria-expanded', 'true');
                                targetProductContainer.style.display = '';
                            }
                        });
                    }, 0);
                }
            }
        }
    }
    customElements.define('menu-swiper', MenuSwiper);
}

if (!customElements.get('mobile-nav')) {
    class MobileNav extends HTMLElement {
        initialized = false;

        constructor() {
            super();

            this.details = this.closest('details');
            this.details?.addEventListener("toggle", (e) => {
                if (this.details.open && !this.initialized) {
                    this.init();
                }
            });
        }

        init() {
            // First initialization.
            this.initSwiper();
            this.setMobileMenuHeight();
            // this.expandSwiper();
            this.initialized = true;
        }

        initSwiper() {
            const swiperContainers = this.querySelectorAll('.mobile-menu-swiper-container');
            this.swipers = [];

            if (swiperContainers.length) {
                for (const swiperElementContainer of swiperContainers) {
                    const swiperElement = swiperElementContainer.querySelector('.swiper');
                    const scrollbar = swiperElementContainer.querySelector('.swiper-scrollbar');

                    const swiper = new Swiper(swiperElement, {
                        slidesPerView: 2,
                        spaceBetween: 15,
                        observer: true,
                        scrollbar: {
                            el: scrollbar || null,
                        },
                        on: {
                            observerUpdate: function () {
                                const parent = $(swiperElement).parent('.mobile-menu-swiper-container[data-hide=true]');
                                parent.css({
                                    'display': 'none'
                                })
                            },
                        },
                    });
                    this.swipers.push(swiper);

                }
            }
        }

        setMobileMenuHeight() {
            const announcementBar = document.querySelector('.announcement-bar-section');
            if (announcementBar) {
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        console.log(
                            `Element is ${entry.isIntersecting ? 'in' : 'out of'} the viewport.`
                        );
                        if (entry.isIntersecting) {
                            const annoucmentBarHeight = announcementBar.offsetHeight;
                            document.documentElement.style.setProperty('--annoucment-bar-height', annoucmentBarHeight + 'px');
                        } else {
                            document.documentElement.style.setProperty('--annoucment-bar-height', 0 + 'px');
                        }
                    });
                });

                observer.observe(announcementBar);
            } else {
                console.warn('Announcement bar not found!');
            }
        }

        expandSwiper() {
            const expandTitles = this.querySelectorAll('.menu-mobile-child-item-title');
            for (const title of expandTitles) {
                title.addEventListener('click', () => {
                    const $swiperContainer = $(title).next('.mobile-menu-swiper-container');

                    if ($swiperContainer.length) {
                        const isExpanded = title.getAttribute('aria-expanded') === 'true';
                        if (isExpanded) {
                            title.setAttribute('aria-expanded', 'false');
                            $swiperContainer.slideUp(300);
                        } else {
                            title.setAttribute('aria-expanded', 'true');
                            $swiperContainer.slideDown(300);
                        }
                    }
                });
            }
        }

    }
    customElements.define('mobile-nav', MobileNav);
}